import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Row, Column, IBox, Button, Select} from '../inspinia';
import FileUpload from './fileUpload';
import RichTextEditor from '../richtext';

import ModalPreview from './modalPreview';

import { EMAIL } from '../../store/tipoListaEmail';

import { callApi } from '../../helpers/methods';

import * as c from '../../helpers/constants'

import { templateAction } from '../../store/template';
import { campanhaAction } from '../../store/campanha';

import { getToken, isAuthenticated } from '../../store/auth';

class EditarTemplate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      form: {
        id: '',
        nome: '',
        mensagem: '',
        file: '',
        empresa: { },
        nomeTemplateHtml: ''
      },
      comboEmpresa: {
        results: undefined
    },
      modalPreviewIsOpen: false,
      loading: false,
      editorBloqueado: true,
      editorPronto: false,
      removeAnexo: false
    };

    this.handleChangeNome = this.handleChangeNome.bind(this);
    this.handleChangeMensagem = this.handleChangeMensagem.bind(this);
    this.handlePreviewToggle = this.handlePreviewToggle.bind(this);
    this.onChangeFile = this.onChangeFile.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.onClickCancelar = this.onClickCancelar.bind(this);
  }

  componentDidMount() {
    this.LoadComboEmpresa();

    const { id } = this.props.match.params;
  
    if (id) {
      const url = `${c.API_CAMPAIGN_URL}/template/${id}`;
      callApi(url, { method: 'GET' }, (response) => {
        if (response && response.id) {
          const empresaId = response.idEmpresa?.id;
          this.setState({
            form: {
              id: response.id,
              nome: response.nome,
              mensagem: response.mensagem,
              empresa: empresaId != null ? { id: empresaId } : {},     
              file: response.idArquivo         
            },
            editorBloqueado: false,
            editorPronto: true
          });
          if (response.idArquivo) {
            this.props.actions.arquivo.setArquivoTemplate({ idArquivoTemplate: response.idArquivo });
          } else {
            this.props.actions.arquivo.setArquivoTemplate(null);
          }
        }
      });
    } else {
      this.setState({ editorBloqueado: false, editorPronto: true});
      this.props.actions.arquivo.setArquivoTemplate(null);
    }
  }

  LoadComboEmpresa() {
          let self = this;
  
          const data = JSON.stringify({
              'id_produto': EMAIL
          });
  
          const url = `${c.API_BASE_URL}/company-user`;
          const options = {
              method: 'POST',
              body: data
          };
  
          self.setState({ ...self.state, loading: true })
  
          callApi(url, options, function (response) {
              self.setState({ ...self.state, loading: false, comboEmpresa: response });
          });
      }

      handleChangeEmpresa = (e) => {
        const raw = e.target.value;
        const id  = Number(raw);
      
        if (isNaN(id)) {
          return;
        }
      
        this.setState(prev => ({
          form: {
            ...prev.form,
            empresa: { id }
          }
        }));
      }

  handleChangeNome = (e) => {
    const nome = e.target.value;
    this.setState((prev) => ({
      form: { ...prev.form, nome }
    }));
  };
  
  handleChangeMensagem = (content) => {
    const texto = content.replace('tagselectorhtml:', '');
    this.setState((prev) => ({
      form: { ...prev.form, mensagem: texto }
    }));
  };

  handlePreviewToggle() {
    this.setState((prevState) => ({
      modalPreviewIsOpen: !prevState.modalPreviewIsOpen
    }));
  }

    onChangeFile(e) {
        const form = this.state.form;

        form.file = e.target.files[0];

        this.setState({ file: e.target.files[0] });

        if (this.state.form.file !== '') {

            if (!isAuthenticated()) {
                throw (c.MESSAGE_ERROR(c.AUTH_ERROR));
            }

            const _token = c.AUTH_HEADER(getToken());

            let data = new FormData();
            data.append('file', form.file);

            const url = `${c.API_CAMPAIGN_URL}/uploadFileHtml`;

            const options = {
                method: 'POST',
                body: data,
                headers: { 'Authorization': _token }
            };

            fetch(url, options).then(async (response) => {
                let json = await response.json();

                if (response.ok) {
                    this.handleChangeTextHtml(json.html);

                } else {
                    c.TOASTER_ERROR(json.message);

                }

            }).catch((exception) => {
                console.log("fetch error" + exception);
            });

        }

    }

    handleChangeTextHtml(texto) {
      texto = texto.replace("tagselectorhtml:", "");
      this.state.form.mensagem = texto;
      this.setState({ posicaomouse1: 0, posicaomouse2: 0 });
    }

    onClickCancelar() {
        this.setState({
          form: {
            id: '',
            nome: '',
            mensagem: '',
            file: '',
            empresa:{ },
            nomeTemplateHtml: ''
          },
          removeAnexo: true
        });
      
        this.props.history.push('/campanha/templates');
      }

      validateForm() {
        const { form } = this.state;
        let message = "";
      
        
      
        if (!form.nome || form.nome.trim() === '') {
          message += "Campo 'Nome do Template' é de preenchimento obrigatório.<br>";
        }
      
        if (!form.mensagem || form.mensagem.trim() === '') {
          message += "O corpo do template não pode estar vazio.<br>";
        }
      
        return message;
      }

    handleSave(e) {
        e.preventDefault();
        if (this.state.loading) return;
    
        let form = { ...this.state.form };
        form.auth = this.props.auth;
        let editor = 'html';
    
        let idArquivoTemplate = '';
    
        if (this.props.arquivo.arquivoTemplate?.idArquivoTemplate) {
          idArquivoTemplate = this.props.arquivo.arquivoTemplate.idArquivoTemplate;
        }
    
        this.setState({ loading: true });

        let validationMessage = this.validateForm();

        if (validationMessage) {
          c.TOASTER_ERROR_LINES(validationMessage);
          this.setState({ loading: false });
          return;
        }
    
        this.props.actions.template.salvarTemplate(form, editor, idArquivoTemplate)
            .then((response) => {
                if (response.status === "BAD_REQUEST") {
                    c.TOASTER_SUCCESS(response.message);
                    return;
                }
    
                if (response) {
                    c.TOASTER_SUCCESS("Template salvo com sucesso!");
                    this.props.history.push('/campanha/templates'); 
                }
    
            })
            .catch((error) => {
              console.error("Erro ao salvar template:", error);
              c.TOASTER_ERROR(error.message);

            })
            .finally(() => {
                this.setState({ loading: false });
            });
    }

  render() {
    const form = this.state.form;
    const isEditando = !!this.props.match.params.id;

    return (
      <div>
        <ModalPreview
          isOpen={this.state.modalPreviewIsOpen}
          toggle={this.handlePreviewToggle}
          preview={this.state.form.mensagem}
        />
        {/* TÍTULO */}
        <Row className="mb-4">
          <Column size="3">
            <h2 className="fs-20 fw-600 text-body m-0">
              {isEditando ? 'Editar Template' : 'Novo Template'}
            </h2>
          </Column>

          <Column size="9">
            <div className="input-group d-block fs-14 text-right">
              {<button type="button" onClick={this.handlePreviewToggle} className="btn btn-link px-3">Pré-visualizar</button>}

              <button name="salvar" onClick={this.handleSave} type="button" className="btn btn-link px-3">Salvar</button>
            </div>
          </Column>
        </Row>

        {/* FORMULÁRIO */}
        <Row className="mb-3">
          <Column size="9">
            <IBox className="mb-0">
              <div>
                <label>Nome do Template</label>
              </div> 
              <div>
                <input
                  onChange={this.handleChangeNome}
                  value={form.nome || ''}
                />
              </div>
              
              <div style={{ maxWidth: '161px', marginTop: '16px'}}>
                <Select
                  name="empresa"
                  selected={form.empresa.id}
                  data={this.state.comboEmpresa}
                  placeholder="Empresa"
                  onChange={this.handleChangeEmpresa}
                />
              </div> 
              <div className="mt-3">
                <label>Selecione o Arquivo HTML</label>
              </div>
              <div>
                <input
                  type="file"
                  name="file"
                  id="validatedCustomFile"
                  required
                  onChange={this.onChangeFile}
                  onClick={(e) => e.target.value = null}
                />
              </div>

              <label className="mt-3">Corpo do Template</label>
              {this.state.editorPronto && (
                <RichTextEditor
                  id="summernote"
                  value={form.mensagem}
                  onChange={this.handleChangeMensagem}
                  onClick={this.click}
                />
              )}
            </IBox>
          </Column>

          <Column size="3" className="container">
            <Row>
              <Column size="12">
                <FileUpload
                  status={this.state}
                  idTemplate={form.id}
                  removeArquivo={this.state.removeAnexo}
                />
              </Column>
            </Row>
          </Column>
        </Row>

        <Row>
          <Column size="3">
            <Button className="btn btn-danger" onClick={this.onClickCancelar}>Cancelar</Button>
          </Column>
        </Row>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    arquivo: state.campanha
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      template: bindActionCreators(templateAction, dispatch),
      arquivo: bindActionCreators(campanhaAction, dispatch)
    }
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditarTemplate));